import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Root from './root';
import { initializeSentry } from './utils';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error("Root element with id 'root' not found.");
}

initializeSentry();

const root = createRoot(rootEl);
root.render(
  <StrictMode>
    <Suspense fallback='loading'>
      <Root />
    </Suspense>
  </StrictMode>
);
